import { createReducer } from '../../../utilities';

import { scope } from '../../../../actions/app/onSite/matches/read';
import { REQUEST_FETCH_MATCH, SUCCESS_FETCH_MATCH, FAIL_FETCH_MATCH } from '../../../../actions/entities/match';
import {
    REQUEST_UPDATE_PLAYER_MATCH_MARK,
    SUCCESS_UPDATE_PLAYER_MATCH_MARK,
    FAIL_UPDATE_PLAYER_MATCH_MARK
} from '../../../../actions/entities/player';

const initialMatchReadState = {
    id: null,
    info: {
        isFetching: false,
        lastAction: null,
        lastPayload: {},
        needRefresh: true,
        updatedAt: null,
        success: false,
        error: false
    }
};

function request(state, action) {
    return {
        ...state,
        info: {
            isFetching: true,
            lastAction: action.type,
            lastPayload: action.payload,
            needRefresh: false,
            updatedAt: null,
            success: false,
            error: false
        }
    };
}

function success(state, action) {
    const { id, payload, receivedAt, success } = action;
    return {
        ...state,
        id: id || state.id,
        info: {
            ...state.info,
            isFetching: false,
            lastPayload: payload,
            needRefresh: false,
            updatedAt: receivedAt,
            success,
            error: false
        }
    };
}

function fail(state, action) {
    const { error, payload } = action;
    return {
        ...state,
        info: {
            ...state.info,
            isFetching: false,
            lastPayload: payload,
            needRefresh: false,
            success: false,
            error
        }
    };
}

export default createReducer(initialMatchReadState, {
    [REQUEST_FETCH_MATCH]: request, [REQUEST_UPDATE_PLAYER_MATCH_MARK]: request,
    [SUCCESS_FETCH_MATCH]: success, [SUCCESS_UPDATE_PLAYER_MATCH_MARK]: success,
    [FAIL_FETCH_MATCH]: fail,       [FAIL_UPDATE_PLAYER_MATCH_MARK]: fail
}, scope);



// WEBPACK FOOTER //
// ./src/reducers/app/onSite/matches/read.js